export enum PopupOpenMode{
    CREATE = 0,
    EDIT = 1
} 


export enum PopupCloseMode{
    CLOSE = 0,
    CANCEL = 1,
    CREATED = 2,
    EDITED = 3,
    ERROR = 4

} 